// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"642e653d","248":"642e653d","431":"642e653d","776":"642e653d"}[chunkId] + ".chunk.css";
};